import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useStoreStatic } from '~/store/store-context';
import { makeChannelAuthorizer } from './PusherConnector.utils';
import { PusherProvider } from './PusherProvider';
export function PusherConnector(param) {
    let { makePusher, children } = param;
    const { getState } = useStoreStatic();
    const pusher = useMemo(()=>makePusher(makeChannelAuthorizer((params)=>getState().actions.authorizePusherChannel(params))), []);
    return /*#__PURE__*/ _jsx(PusherProvider, {
        pusher: pusher,
        children: children
    });
}
